import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocationService } from '../services/location/location.service';
import { PAGE } from 'src/app/routes';
import { InitService } from '../services/init/init.service';

export const initialisedGuard: CanActivateFn = async () => {
  const initService = inject(InitService);
  const locationService = inject(LocationService);
  const router = inject(Router);

  if (initService.initialised()) {
    const job = locationService.isCountryBlocked();
    job.showNoInternetRetry();
    job.addErrorHandler().reloadWindow();
    const isBlocked = await job.runNoThrow();
    if (isBlocked) {
      router.navigate([PAGE.UNAVAILABLE]);
      return false;
    }
    return true;
  } else {
    router.navigate([PAGE.LOADING]);
    return false;
  }
};
